import { createSelector } from '@ngrx/store';
import { DisputeReasonsStore } from '../reducers/dispute.reducer';

export const selectBuyerVisibleDisputeReasons = createSelector(
  DisputeReasonsStore,
  (state) => {
    return state?.filter(
      (reason) =>
        reason.active &&
        (reason.visibility === 'All' || reason.visibility === 'External'),
    );
  },
);

export const selectSupplierVisibleDisputeReasons = createSelector(
  DisputeReasonsStore,
  (state) => {
    return state?.filter(
      (reason) =>
        reason.active &&
        (reason.visibility === 'All' || reason.visibility === 'Internal'),
    );
  },
);
